import { ProtocolIcon } from './chunk-EPXDPMBL.js';
import { ProtocolBadge } from './chunk-XCW4JPLG.js';
import { CONDITIONAL_TOKENS, CONDITIONAL_TOKENS_EVENTS, CONDITIONAL_TOKENS_COMPONENTS, CONDITIONAL_TOKENS_VERBS, pickField, CONDITIONAL_TOKENS_FIELDS, CONDITIONAL_TOKENS_LABELS, ProtocolValue, SectionCard, FactGrid, ProtocolParamList } from './chunk-WCNTYBII.js';
import { Scale } from 'lucide-react';
import { jsx, jsxs } from 'react/jsx-runtime';

function outcomeCount(value) {
  return Array.isArray(value) ? value.length : void 0;
}
function ConditionalTokensPosition({
  event: event2,
  hint,
  chain,
  renderAddress
}) {
  const pid = hint.protocolId ?? CONDITIONAL_TOKENS.protocolId;
  const verb = CONDITIONAL_TOKENS_VERBS[event2.name ?? ""];
  const trader = pickField(event2.params, CONDITIONAL_TOKENS_FIELDS.stakeholder);
  const collateral = pickField(event2.params, CONDITIONAL_TOKENS_FIELDS.collateralToken);
  const conditionId = pickField(event2.params, CONDITIONAL_TOKENS_FIELDS.conditionId);
  const partition = pickField(event2.params, CONDITIONAL_TOKENS_FIELDS.partition, CONDITIONAL_TOKENS_FIELDS.indexSets);
  const amount = pickField(event2.params, CONDITIONAL_TOKENS_FIELDS.payout, CONDITIONAL_TOKENS_FIELDS.amount);
  const outcomes = outcomeCount(partition);
  const address = (v) => typeof v === "string" && renderAddress ? renderAddress(v, { chain }) : /* @__PURE__ */ jsx(ProtocolValue, { value: v });
  const facts = [
    { label: CONDITIONAL_TOKENS_LABELS.market, value: /* @__PURE__ */ jsx(ProtocolValue, { value: conditionId }), when: conditionId },
    { label: CONDITIONAL_TOKENS_LABELS.trader, value: address(trader), when: trader },
    { label: CONDITIONAL_TOKENS_LABELS.collateral, value: address(collateral), when: collateral },
    {
      label: verb?.amountLabel ?? CONDITIONAL_TOKENS_LABELS.staked,
      value: /* @__PURE__ */ jsx(ProtocolValue, { value: amount }),
      when: amount != null
    },
    { label: CONDITIONAL_TOKENS_LABELS.outcomes, value: /* @__PURE__ */ jsx(ProtocolValue, { value: outcomes }), when: outcomes != null }
  ];
  return /* @__PURE__ */ jsxs(
    SectionCard,
    {
      title: /* @__PURE__ */ jsxs("span", { className: "inline-flex items-center gap-2", children: [
        /* @__PURE__ */ jsx(ProtocolIcon, { protocolId: pid, icon: Scale }),
        /* @__PURE__ */ jsx("span", { className: "text-sm font-semibold", children: hint.label ?? verb?.title ?? event2.name ?? "Conditional tokens" })
      ] }),
      protocolId: pid,
      meta: /* @__PURE__ */ jsx(ProtocolBadge, { protocolId: pid }),
      children: [
        verb && /* @__PURE__ */ jsx("p", { className: "mb-2 text-xs text-muted-foreground", children: verb.note }),
        /* @__PURE__ */ jsx(FactGrid, { facts }),
        /* @__PURE__ */ jsxs("details", { className: "mt-3 min-w-0", children: [
          /* @__PURE__ */ jsx("summary", { className: "cursor-pointer text-xs text-muted-foreground hover:text-foreground", children: "All event fields" }),
          /* @__PURE__ */ jsx("div", { className: "pt-2", children: /* @__PURE__ */ jsx(ProtocolParamList, { params: event2.params, emptyLabel: "No decoded fields" }) })
        ] })
      ]
    }
  );
}

// src/protocols/conditional_tokens/index.ts
var PID = CONDITIONAL_TOKENS.protocolId;
var C = CONDITIONAL_TOKENS_COMPONENTS;
var event = (name) => ({
  protocolId: PID,
  event: name,
  component: C.position,
  summaryFields: []
});
var CONDITIONAL_TOKENS_HINTS = {
  valueHints: [],
  callHints: [],
  eventHints: [
    event(CONDITIONAL_TOKENS_EVENTS.positionSplit),
    event(CONDITIONAL_TOKENS_EVENTS.positionsMerge),
    event(CONDITIONAL_TOKENS_EVENTS.payoutRedemption)
  ]
};
function registerConditionalTokens(registry) {
  registry.registerEvent(C.position, ConditionalTokensPosition);
  registry.registerHints(CONDITIONAL_TOKENS_HINTS);
  return registry;
}

export { CONDITIONAL_TOKENS_HINTS, ConditionalTokensPosition, registerConditionalTokens };
//# sourceMappingURL=chunk-AHNSYHKJ.js.map
//# sourceMappingURL=chunk-AHNSYHKJ.js.map